<template>
  <div>
    <common-list
      :init="filterInit"
      ref="list"
      url="User/GetList"
      @currentrow="handlerCurrentRow"
    >
      <!-- 数检索 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="登录名" prop="Loginname">
            <el-input
              v-model.trim="filter.Loginname"
              placeholder="登录名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="真实姓名" prop="Username">
            <el-input
              v-model.trim="filter.Username"
              placeholder="真实姓名"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </template>
      <!-- 功能按钮 -->
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('UserAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('UserEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="auth('UserDelete')"
          >删除</el-button
        >
        <el-button type="blue" icon="el-icon-tickets" @click="show"
          >查看</el-button
        >
        <el-button
          type="warning"
          @click="resetPassword"
          v-if="auth('ResetPassword')"
          >重置密码</el-button
        >
        <!-- <el-button
          type="danger"
          @click="setUserStatus"
          v-if="
            auth('SetUserStatus') &&
            currentrow &&
            currentrow.UserStatus != '冻结'
          "
          >{{ isNormal ? "锁定" : "解除锁定" }}</el-button
        > -->
        <el-button
          type="warning"
          v-if="auth('UserOffline') && currentrow && currentrow.IsOnline == '1'"
          @click="userOffline"
        >
          强制下线
        </el-button>
        <el-button
          type="success"
          v-if="auth('SendMessage') && currentrow && currentrow.IsOnline == '1'"
          @click="sendMessage"
        >
          发送实时消息
        </el-button>
      </template>
      <!-- 数据列表 -->
      <template v-slot:body>
        <el-table-column
          label="所属机构"
          prop="CompanyName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="登录名"
          prop="Loginname"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="真实姓名"
          prop="Username"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="用户角色" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ (row.RoleList || []).join(",") }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="行政区划"
          prop="AreaName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="用户状态"
          prop="UserStatus"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column label="在线状态" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ row.IsOnline == "1" ? "在线" : "离线" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="密码有效期" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ row.PasswordVaildDate | datetime }}</span>
          </template>
        </el-table-column> -->
      </template>
    </common-list>
    <!-- 添加编辑 -->
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="用户管理"
      getUrl="User/GetItemByID"
      addUrl="User/Add"
      editUrl="User/Edit"
      width="800px"
      labelWidth="120px"
      clearable
    >
      <template v-slot="{ form }">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item label="拆解机构">
                <StationSelect
                  v-model="form.OrgId"
                  :isShow="true"
                ></StationSelect>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="登录名"
                prop="Loginname"
                :rules="[$g.validRequired, $g.validLen(20)]"
              >
                <el-input
                  v-model.trim="form.Loginname"
                  placeholder="登录名"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="真实姓名"
                prop="Username"
                :rules="[$g.validRequired, $g.validLen(30)]"
              >
                <el-input
                  v-model.trim="form.Username"
                  placeholder="真实姓名"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="电话号码"
                prop="Tel"
                :rules="[$g.validRequired, $g.validPhone]"
              >
                <el-input
                  v-model.trim="form.Tel"
                  placeholder="电话号码"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="用户岗位"
                prop="UserPosition"
                :rules="$g.validRequired"
              >
                <RemoteSelect
                  v-model="form.UserPosition"
                  url="DataDic/GetItemsByType?dicType=UserPosition"
                  code="DicCode"
                  name="DicName"
                ></RemoteSelect>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="用户角色"
                prop="RoleList"
                :rules="$g.validRequired"
              >
                <RemoteSelect
                  v-model="form.RoleList"
                  :url="'Role/GetList?Orgid='+ (form.OrgId==undefined?1:form.OrgId)"
                  code="RoleId"
                  name="RoleName"
                  :multiple="true"
                ></RemoteSelect>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </template>
    </add-edit>

    <show-item
      :array="showitem"
      title="用户"
      width="800px"
      :col="2"
    ></show-item>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ["1"],
      filterInit: {
        IsRecurrence: "1",
      },
      aeitem: {},
      showitem: [],
    };
  },
  computed: {
    isNormal() {
      if (!this.currentrow) {
        return false;
      }
      return this.currentrow.UserStatus == "正常" ? true : false;
    },
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.activeNames = ["1"];
      this.$get("User/GetIsDefaultRuleList").then((r) => {
        this.$refs.addedit.type = "add";
        let rule = r.Result;
        this.aeitem = {
          UserStatus: "1",
          ...rule,
        };
        this.PasswordRuleChange(rule.RegexRule);
      });
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.activeNames = ["1"];
      this.$refs.addedit.type = "edit";
      this.aeitem = { UId: this.currentrow.UId,OrgId:this.currentrow.OrgId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除姓名为【${this.currentrow.Username}】的用户, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("User/Delete", {
            UId: this.currentrow.UId,
          }).then(() => {
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    PasswordRuleChange(Id) {
      if (this.$refs.addedit.type == "add") {
        if (!Id) {
          this.$set(this.$refs.addedit.form, "PasswordVaildDate", "");
          return;
        }
        this.$get("PasswordRule/GetPasswordRuleByID", {
          PwdruleId: Id,
        }).then((r) => {
          let PwdVaildDays = r.Result.PwdVaildDays || 0;
          let day = this.$dateformat(this.$dayjs().add(PwdVaildDays, "day"));
          this.$set(this.$refs.addedit.form, "PasswordVaildDate", day);
        });
      }
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      let r = { ...this.currentrow };
      let array = [];
      array.push({
        title: "所属机构",
        value: r.CompanyName,
      });
      array.push({
        title: "登录名",
        value: r.Loginname,
      });
      array.push({
        title: "真实姓名",
        value: r.Username,
      });
      array.push({
        title: "电话号码",
        value: r.Tel,
      });
      // array.push({
      //   title: "用户状态",
      //   value: r.UserStatus,
      // });
      // array.push({
      //   title: "密码有效期",
      //   value: this.$dateformat(r.PasswordVaildDate),
      // });
      // array.push({
      //   title: "当前连续登录失败次数",
      //   value: r.FailureCount,
      //   labelWidth: "260px",
      // });
      // array.push({
      //   title: "在线状态",
      //   value: r.IsOnline == "1" ? "在线" : "离线",
      // });
      // array.push({
      //   title: "密码规则",
      //   value: r.RegexRule,
      // });
      // array.push({
      //   title: "账户规则",
      //   value: r.AccountRule,
      // });
      // array.push({
      //   title: "时间规则",
      //   value: r.TimeRule,
      // });
      // array.push({
      //   title: "终端规则",
      //   value: r.TerminalRule ? r.TerminalRule.join(",") : "",
      // });

      this.showitem = array;
    },
    resetPassword() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$put("User/ResetPwdByID", {
        UId: this.currentrow.UId,
      }).then((r) => {
        this.$message.success("重置成功，新密码为：123456");
      });
    },
    setUserStatus() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$put("User/LockOrUnlockUserByID", {
        UId: this.currentrow.UId,
      }).then((r) => {
        this.$message.success("操作成功");
        this.$refs.list.getTableData();
      });
    },
    userOffline() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$get("User/UpdateOnlineStatusByID", {
        UId: this.currentrow.UId,
      }).then((r) => {
        this.$message.success("操作成功");
        this.$refs.list.getTableData();
      });
    },
    sendMessage() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$prompt("", `给【${this.currentrow.Username}】发送实时消息`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
        closeOnClickModal: false,
        inputValidator: (v) => {
          if (!v) {
            return "请输入消息内容";
          }
          if (v.length > 50) {
            return "内容应在50个字以内";
          }
        },
      })
        .then(({ value }) => {
          this.$post("User/SendMsgByUser", {
            UId: this.currentrow.UId,
            Msg: value,
          }).then((r) => {
            this.$message.success("发送成功");
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>